import { pickLocalized } from "../../../i18n/localizedContent";
import {
  DEFAULT_UPDATE_SECTION_KEY,
  DEFAULT_UPDATE_ICON_KEY,
  UPDATE_ICON_KEYS,
  UPDATE_SECTION_KEYS,
  getUpdateSection,
} from "./updatesConstants";

export const parseUpdateAddress = (address) => {
  const raw = String(address || "").trim();
  if (!raw) return {};

  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object") return parsed;
  } catch {
    // Legacy values are plain library ids or icon keys.
  }

  if (UPDATE_ICON_KEYS.has(raw)) return { icon: raw };
  if (/^\d+$/.test(raw)) return { resourceId: raw };
  return {};
};

export const createUpdateAddress = ({ icon, resourceId, section }) =>
  JSON.stringify({
    icon: UPDATE_ICON_KEYS.has(icon) ? icon : DEFAULT_UPDATE_ICON_KEY,
    section: UPDATE_SECTION_KEYS.has(section)
      ? section
      : DEFAULT_UPDATE_SECTION_KEY,
    ...(resourceId ? { resourceId: String(resourceId) } : {}),
  });

export const resolveUpdateSectionKey = (change) => {
  const parsedAddress = parseUpdateAddress(change?.address);
  if (UPDATE_SECTION_KEYS.has(parsedAddress.section)) {
    return parsedAddress.section;
  }
  if (change?.type === "game") return "games";
  if (change?.type === "library") return "library";
  return DEFAULT_UPDATE_SECTION_KEY;
};

/** Заголовок и тело: первая строка или блок до \\n\\n — заголовок. */
export const splitTitleAndBody = (text) => {
  const raw = String(text || "").trim();
  if (!raw) return { title: "", body: "" };

  const doubleBreak = raw.split(/\n\n+/);
  if (doubleBreak.length >= 2) {
    return {
      title: doubleBreak[0].trim(),
      body: doubleBreak.slice(1).join("\n\n").trim(),
    };
  }

  const lines = raw.split("\n");
  if (lines.length === 1) {
    return { title: lines[0].trim(), body: "" };
  }

  return {
    title: lines[0].trim(),
    body: lines.slice(1).join("\n").trim(),
  };
};

export const composeChangeText = (title, body) => {
  const t = String(title || "").trim();
  const b = String(body || "").trim();
  if (t && b) return `${t}\n\n${b}`;
  return t || b;
};

export const resolveUpdateIconKey = (change) => {
  const parsedAddress = parseUpdateAddress(change?.address);
  if (UPDATE_SECTION_KEYS.has(parsedAddress.section)) {
    return getUpdateSection(parsedAddress.section).iconKey;
  }
  if (UPDATE_ICON_KEYS.has(parsedAddress.icon)) {
    return parsedAddress.icon;
  }
  if (change?.icon_key && UPDATE_ICON_KEYS.has(change.icon_key)) {
    return change.icon_key;
  }
  if (change?.type === "library") {
    return "book";
  }
  if (change?.type === "game") {
    return "gamepad";
  }
  if (
    change?.type === "custom" &&
    change?.address &&
    UPDATE_ICON_KEYS.has(change.address)
  ) {
    return change.address;
  }
  return DEFAULT_UPDATE_ICON_KEY;
};

export const getLocalizedChangeText = (change, locale = "ru") =>
  pickLocalized(change?.text, change?.text_en, locale);

export const resolveUpdateDisplay = (
  change,
  libraryFile,
  t = (value) => value,
  locale = "ru",
) => {
  const sourceText = getLocalizedChangeText(change, locale);
  const { title, body } = splitTitleAndBody(sourceText);
  const libraryName = pickLocalized(
    libraryFile?.name,
    libraryFile?.name_en,
    locale,
  );

  if (change?.type === "library" && libraryFile) {
    return {
      title: title || libraryName || t("Новый материал"),
      body: body || sourceText || "",
      libraryFile,
    };
  }

  return {
    title: title || t("Обновление SPEAKID"),
    body: body || sourceText || "",
    libraryFile: null,
  };
};

export const getUpdateResourceId = (change) =>
  parseUpdateAddress(change?.address).resourceId || String(change?.address || "");
